<template>
  <section>
    <div class="content_bg">
      <div class="content">

        <div class="header">
          <p class="tag">개발사 선택 전, 꼭 읽어보세요</p>
          <h2 class="title">혹시 이런 경험, 있으신가요?</h2>
          <p class="subtitle">
            개발사를 잘못 선택하면 시간과 예산 모두 잃습니다.<br />
            실제로 일어나는 일들, 미리 알고 계세요.
          </p>
        </div>

        <div class="cards">
          <div class="card" v-for="item in items" :key="item.id">
            <div class="card_icon">{{ item.icon }}</div>
            <p class="card_category">{{ item.category }}</p>
            <p class="card_quote">"{{ item.quote }}"</p>
            <p class="card_desc">{{ item.desc }}</p>
          </div>
        </div>

        <div class="bottom_message">
          <p>먼데이리스는 이 모든 상황을 <span style="color: #215fe6; font-weight: 700;">경험했고, 해결책을 만들었습니다.</span></p>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          id: 1,
          icon: "📵",
          category: "연락두절",
          quote: "마감 2주 전인데 갑자기 연락이 안 돼요.",
          desc: "다른 프로젝트에 치여서, 혹은 이유도 없이. 당신의 서비스는 그렇게 방치됩니다.",
        },
        {
          id: 2,
          icon: "💸",
          category: "추가 비용 청구",
          quote: "그건 처음 계약 범위에 없었어요. 별도 비용입니다.",
          desc: "견적서에 없던 항목들이 하나씩 추가됩니다. 최초 견적의 1.5~2배가 되는 청구서.",
        },
        {
          id: 4,
          icon: "🐛",
          category: "런칭 후 방치",
          quote: "버그요? 유지보수 계약을 안 하셨잖아요.",
          desc: "살아있는 서비스엔 반드시 버그가 생깁니다. 책임지는 파트너 없이 런칭하면 혼자 감당해야 합니다.",
        },
        {
          id: 5,
          icon: "😤",
          category: "결과물 불일치",
          quote: "저는 분명히 그렇게 설명했는데, 완전히 다르게 나왔어요.",
          desc: "말로는 다 된다고 했는데, 결과물은 전혀 달랐습니다. 소통하지 않는 개발의 결말입니다.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  background-color: #0d1117;
  padding: 100px 20px;
}

.content {
  width: 1140px;
  max-width: 1140px;
}

/* 헤더 */
.header {
  text-align: center;
  margin-bottom: 60px;
}

.tag {
  display: inline-block;
  background-color: rgba(247, 87, 87, 0.15);
  color: #f75757;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1px;
  padding: 6px 16px;
  border-radius: 20px;
  margin-bottom: 20px;
}

.title {
  font-size: 42px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -1px;
  margin: 0 0 16px 0;
}

.subtitle {
  font-size: 17px;
  font-weight: 300;
  color: #8b95a1;
  line-height: 1.8;
}

/* 카드 그리드 */
.cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 60px;
}

.card {
  background-color: #161b22;
  border: 1px solid #21262d;
  border-left: 4px solid #f75757;
  border-radius: 12px;
  padding: 28px 24px;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.card:hover {
  transform: translateY(-4px);
  border-color: #f75757;
  border-left-color: #f75757;
  background-color: #1c2128;
}

.card_icon {
  font-size: 28px;
  margin-bottom: 10px;
}

.card_category {
  font-size: 12px;
  font-weight: 600;
  color: #f75757;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.card_quote {
  font-size: 18px;
  font-weight: 700;
  color: #e6edf3;
  line-height: 1.6;
  margin-bottom: 12px;
}

.card_desc {
  font-size: 14px;
  font-weight: 300;
  color: #6e7681;
  line-height: 1.8;
}

/* 하단 메시지 */
.bottom_message {
  text-align: center;
  border-top: 1px solid #21262d;
  padding-top: 40px;
  font-size: 18px;
  font-weight: 400;
  color: #8b95a1;
}

/* 반응형 */
@media screen and (max-width: 1440px) {
  .content {
    width: 100%;
  }

  .cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .title {
    font-size: 32px;
  }
}

@media screen and (max-width: 768px) {
  .content_bg {
    padding: 60px 20px;
  }

  .cards {
    grid-template-columns: 1fr;
  }

  .title {
    font-size: 28px;
  }

  .subtitle {
    font-size: 15px;
  }
}
</style>
